import { type Setup, api } from '@here/api'
import { createResource, createSignal } from 'solid-js'

export function useSetups() {
	const [updateSetup, setUpdateSetup] = createSignal<Setup>()
	const [deleteSetup, setDeleteSetup] = createSignal<string>()

	const handleUpdateSetup = async (updateSetup: Setup) => {
		const { data } = await api()
			.from('setup')
			.update(updateSetup)
			.eq('id', updateSetup.id)
		return data
	}

	const handleDeleteSetup = async (id: string) => {
		const { data } = await api().from('setup').delete().eq('id', id)
		return data
	}

	const [updateSetupResource] = createResource(updateSetup, handleUpdateSetup)
	const [deleteSetupResource] = createResource(deleteSetup, handleDeleteSetup)

	return {
		setUpdateSetup,
		updateSetupResource,
		setDeleteSetup,
		deleteSetupResource,
	}
}
